import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";
import { type InferOutput, array, boolean, nullable, number, object, optional, pipe, string, trim } from "valibot";

export const UpdatePersonalizationFormSchema = object({
    personality: pipe(
        string(),
        trim()
    ),
    memories: array(
        object({
            memoryId: nullable(number()),
            value: pipe(
                string(),
                trim()
            )
        })
    ),
    trackingOptOut: optional(boolean())
});

export type UpdatePersonalizationForm = InferOutput<typeof UpdatePersonalizationFormSchema>;
export type Memory = UpdatePersonalizationForm["memories"][number];

export const useUpdatePersonalizationForm = (defaultValues: Partial<UpdatePersonalizationForm>) => {
    return useForm<UpdatePersonalizationForm>({
        defaultValues,
        resolver: valibotResolver(UpdatePersonalizationFormSchema)
    });
};
